module.exports = __webpack_public_path__ + "img/TheMix_cls_TT3_.d04e8dd3.svg";